import axios from "axios";
import React, { useState, useEffect } from "react";
import CreaInfraestructuraMetros from "./Equipos/CreaModals/CreaInfraestructuraMetros";
import Cookies from "universal-cookie";

function Titulo21SeccionC(props) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);

  // 🔹 Obtener datos (GET)
  const obtenerDatos = () => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerInfraestructuraMetrosPorSolicitudId?SolicitudId=" +
        props.idSolicitud,
    })
      .then((res) => {
        setList(res.data || []);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    obtenerDatos();
  }, [props.idSolicitud]);

  const url = window.location.href;
  const partesURL = url.split("/");
  const nombreRuta = partesURL[partesURL.indexOf("#") + 1];

  return (
    <div className="container-fluid">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            2.1.1 Registre en metros cuadrados el área física total y área
            construida que tiene la institución y por cada una de sus sedes:
          </h6>
        </div>

        <div className="card-body">
          {cookies.get("tipo_Usuario") == 2 &&
            nombreRuta === "ProcesoAutoevaluacion" && (
              <CreaInfraestructuraMetros
                idSolicitud={props.idSolicitud}
                onCreate={obtenerDatos} // 👈 CLAVE
              />
            )}

          <div className="table-responsive">
            <table className="table table-bordered" width="100%">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Sede</th>
                  <th>Metros Físicos</th>
                  <th>Metros Construidos</th>
                  <th>Sala Espera</th>
                  <th>Urgencias</th>
                  <th>Radiología</th>
                  <th>Cirugía</th>
                  <th>Partos</th>
                  <th>SolicitudId</th>
                </tr>
              </thead>
              <tbody>
                {list.length === 0 && (
                  <tr>
                    <td colSpan="10" className="text-center">
                      No hay registros
                    </td>
                  </tr>
                )}

                {list.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.sede}</td>
                    <td>{item.metros_fisicos}</td>
                    <td>{item.metros_Construidos}</td>
                    <td>{item.metros_Sala_Espera}</td>
                    <td>{item.metros_Urgencias}</td>
                    <td>{item.metros_Radiologia}</td>
                    <td>{item.metros_Cirugia}</td>
                    <td>{item.metros_Partos}</td>
                    <td>{item.solicitudId}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Titulo21SeccionC;
